import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=7d78839e&"
import script from "./CompanyPage.vue?vue&type=script&lang=js&"
export * from "./CompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports